/* oxlint-disable typescript/no-explicit-any */
// Ошибка в типах при кодогенерации
export const isLeadFactory = (agent: any): boolean => agent.isLeadFactory;
